import { SortDirection } from './sort';

export const DEFAULT_LIMIT = 20;

export const SORT_SEQUENCE = {
  [SortDirection.RESET]: {
    next: SortDirection.ASC
  },
  [SortDirection.ASC]: {
    next: SortDirection.DESC
  },
  [SortDirection.DESC]: {
    next: undefined
  }
};
